export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "inventory_movement": {
            "movement_type": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tipo"])},
            "registered_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha"])},
            "quantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad"])},
            "unit_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precio unitario"])},
            "total_amount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monto total"])},
            "comments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Comentario"])},
            "document_number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Documento"])},
            "inventory_item": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Item"])},
            "supplier": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proveedor/Cliente"])}
          }
        }
      }
    }
  })
}